export const PromoVideo = {
  URL: window.PROMO_VIDEO_URL,
  LOCALSTORAGE_FIELD: 'promo',
};
